import { React } from 'react';
import { Flex, Image, Text, Button } from '@chakra-ui/react';
import noInterviewsImage from '../../images/no-interviews.png';

function InterviewsError({ onRetry, title = 'There was an error loading the interviews!' }) {
  return (
    <Flex flexDirection='column' alignItems='center' maxWidth='715px' mx='auto' mt='100px' textAlign='center'>
      <Image src={noInterviewsImage} alt='No Interviews' />
      <Text fontSize='20px' fontWeight='700' mt='40px' mb='16px'>
        {title}
      </Text>
      <Text fontSize='20px' color='gray.600'>
        Unexpected Error
      </Text>
      {onRetry && (
        <Button mt='32px' colorScheme='blue' onClick={onRetry}>
          Try again
        </Button>
      )}
    </Flex>
  );
}

export default InterviewsError;
